// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__GIAAZ","text":"LoginForm_text__HHq8V","or":"LoginForm_or__DGiuF","form_error_message":"LoginForm_form_error_message__j8aWx"};